import React from 'react';
import DOMPurify from 'dompurify';

type Props = {
	label: string;
	content: string;
};

export function Thumbnail({ label, content }: Props) {
	return (
		<>
			<span>{label}</span>
			{/* eslint-disable-next-line react/no-danger */}
			<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
		</>
	);
}
